module.exports = __webpack_public_path__ + "img/beast-tyrant.ef19894f.png";